export class NigmaMessage {
    readonly id: string;
    readonly text: string;
    readonly sender: string;
    readonly image?: string;
    readonly customKeyboard?: boolean;
    readonly delay?: number;
    readonly options?: string[][];

    constructor({ text, sender, image, delay, customKeyboard, options }:
        { text: string; sender: string; image?: string; customKeyboard?: boolean; delay?: number; options?: string[][]; }) {
        this.id = Math.random().toString(16).slice(2);
        this.text = text;
        this.sender = sender;
        this.image = image;
        this.customKeyboard = customKeyboard;
        this.delay = delay;
        this.options = options;
    }
}